import api from "./client";

// TenantKnowledge — the assistant's business knowledge (agent_actions lane).
// Versioned + append-only: a save creates a NEW version and flips the prior
// one off is_current, so edits are never destructive. Contract owned by the
// Lane-C agent surface.
//
//   GET  /api/agent/knowledge/  -> the is_current row (all fields + version,
//                                  created_at, updated_by) or { present: false }
//   POST /api/agent/knowledge/  -> creates a new version (atomic), returns
//                                  { version, created_at }. Body = the fields.
//
// Field JSON shapes the agent reads (must match):
//   faq                = [{ q, a }]
//   escalation_rules   = [{ when, action }]
//   business_hours     = { mon: { open, close }, ... }  (omit a day = closed)
//   service_area       = { zips: [...], radius_miles, center: { lat, lng } }
//   scheduling_policies= { buffer_minutes, same_day_allowed, min_lead_hours, max_days_out }
//   greeting, voice_persona = plain text

export const getKnowledge = () => api.get("/agent/knowledge/");

export const saveKnowledge = (payload) => api.post("/agent/knowledge/", payload);
